import { FC } from 'react';
import { Tooltip as TooltipAnt } from 'antd';
import { TooltipProps } from 'antd/es/tooltip';
import { StyledGlobalTooltip } from './styles';

const Tooltip: FC<TooltipProps> = (props) => {
  return (
    <>
      <StyledGlobalTooltip />
      <TooltipAnt
        {...props}
        placement={props.placement ?? 'bottomLeft'}
        overlayStyle={props.overlayStyle ?? { padding: 0 }}>
        {props.children}
      </TooltipAnt>
    </>
  );
};

export default Tooltip;
